(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skb-marketplace-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pwskb-slider]').forEach(function(slider){
  var rail=slider.querySelector('.pwskb-promo__rail');
  var prev=slider.querySelector('.pwskb-promo__arrow--prev');
  var next=slider.querySelector('.pwskb-promo__arrow--next');
  if(!rail||!prev||!next)return;
  function move(dir){rail.scrollBy({left:rail.clientWidth*dir,behavior:'smooth'});}
  prev.addEventListener('click',function(){move(-1);});
  next.addEventListener('click',function(){move(1);});
  setInterval(function(){
    var max=rail.scrollWidth-rail.clientWidth;
    if(rail.scrollLeft>=max-5){rail.scrollTo({left:0,behavior:'smooth'});}
    else{move(1);}
  },5000);
});

  } catch(e) { console.error(e); }
})();
})();
